export const USER_ROLES = {
  ADMIN: "admin-carrefour",
  REFERENT: "referent"
};
